class DateUtils {
    static get atFormat() {
        return 'M/D/YYYY [at] h:mma';
    }
}

export default DateUtils;